export default "__VITE_ASSET__BGqi0LOx__"